




























































import User from '@/models/user';
import {API} from '@/services/api/api';
import {Vue, Component, Prop} from 'vue-property-decorator';
import {mapActions, mapGetters} from 'vuex';
@Component({
  methods: {
    ...mapActions(['setInspectionData', 'showSuccessToast', 'showErrorToast']),
  },
  computed: {
    ...mapGetters(['getInspectionData']),
  },
})
export default class InspectionThirdStep extends Vue {
  @Prop() isReadOnly!: boolean;
  @Prop() canMappedData!: boolean;

  getInspectionData: any;
  setInspectionData: any;
  userList: User[] = [];
  showSuccessToast: any;
  showErrorToast: any;
  isScreenLoading = true;
  userId: number = null;
  selectedUsers: number[] = [];
  mailToValidationMsg = '';
  extraEmail = '';
  isAllUserSelected = false;

  mounted() {
    this.getUserList();
    //

    if (this.canMappedData) {
      this.bindDataFieldsFromStore();
    }
  }

  validateMailTo() {
    if (this.userId === null) {
      this.mailToValidationMsg = 'This field is required';
      return false;
    } else {
      this.mailToValidationMsg = '';
      return true;
    }
  }

  async getUserList() {
    try {
      let response = await API.getUserList();

      if (response.data) {
        let users: User[] = response.data;
        this.userList = users;
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (e) {
      this.showErrorToast({msg: 'Network error'});
    } finally {
      this.isScreenLoading = false;
    }
  }

  addAllUserInCC() {
    if (this.isAllUserSelected) {
      this.selectedUsers = [];
    } else {
      this.selectedUsers = this.userList.map((me: any) => me.internalId);
    }
  }

  addUserToList(isUserSelected, internalId, id) {
    if (!isUserSelected) {
      this.selectedUsers = this.selectedUsers.filter((a) => a !== internalId);
    } else {
      this.selectedUsers.push(internalId);
    }
    //
  }

  saveThirdStepData() {
    if (this.validateMailTo()) {
      this.setInspectionData({
        key: 'thirdStep',
        payload: {
          mailToUserId: this.userId,
          mailCcUserId: this.selectedUsers,
          mailCcEmailAddress: this.extraEmail,
          isAllUserSelected: this.isAllUserSelected,
        },
      });
      this.$emit('onNextClick', 3);
    }
  }

  bindDataFieldsFromStore() {
    const data = this.getInspectionData.thirdStep;
    //

    this.userId = data.mailToUserId;
    this.selectedUsers = data.mailCcUserId;
    this.extraEmail = data.mailCcEmailAddress;
    this.isAllUserSelected = data.isAllUserSelectedpo;
  }
}
